import React from "react";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";
import Avatar from "Components/common/Avatar/Avatar";

class Members extends React.Component {
    render() {
        const { note } = this.props;
        const creator = note.creator;
        const users = [...note.tagged_users.filter(m => m.user && m.user.id === creator.id), ...note.tagged_users.filter(m => m.user && m.user.id !== creator.id)];

        return (
            <div style={{display:'flex', alignItems: 'center', justifyContent: "center"}}>
                {users && [...users].slice(0, 4).map((m, i) => <Avatar key={`notesColumn_${m.user.id}_${i}`} id={`${note.id}_${m.user.id}`} name={`${m.user.firstName} ${m.user.lastName}`} image={m.user.avatar !== "default.png" ? `/api/file/profile_pictures/${m.user.avatar}` : null} />)}
                {users && users.length > 4 && (
                    <div class="avatarElement">
                        <div class="avatarContainer"   data-tooltip-id={`memberCount_${note.id}_tooltip`}>
                            <div class="avatarItem">+{users.length - 4}</div>
                        </div>
                        <Tooltip id={`memberCount_${note.id}_tooltip`}  place="bottom" effect="solid">
                            {users && users.filter(m => m.user).slice(4, users.length).map((m, i) => <p key={`otherMembers_${note.id}_${i}`}>{`${m.user.firstName} ${m.user.lastName}`}</p>)}
                        </Tooltip>
                    </div>
                )}
            </div>
        );
    }
}

Members.defaultProps = {
    note: {}
}

export default Members;